import React, { useEffect } from 'react'
import { useSelector, useDispatch, useStore } from 'react-redux'
import SidebarItems from '../lists/SidebarItems'
import { itemIdsToItems } from '../item/itemsTransformers'
import { fetchUserFeedItems } from '../item/itemsActions'

const SidebarUserFeed = () => {
  const dispatch = useDispatch()
  const itemIds = useSelector((state) => state.items.userFeeds.get('itemIds'))
  const loading = useSelector((state) => state.items.userFeeds.get('loading'))
  const failedToLoad = useSelector((state) => state.items.userFeeds.get('failedToLoad'))
  const shouldUpdate = useSelector((state) => state.items.userFeeds.get('shouldUpdate'))

  // Using store.getState() to avoid re-rendering on every tiny change in the state
  const state = useStore().getState()
  const items = itemIdsToItems(state, itemIds)

  useEffect(() => {
    if (shouldUpdate) {
      // Trigger fetch after changes to profile (eg. changing feed category)
      dispatch(fetchUserFeedItems())
    }
  }, [shouldUpdate, dispatch])

  useEffect(() => {
    const interval = setInterval(() => {
      if (!window.document.hidden) {
        dispatch(fetchUserFeedItems(300))
      }
    }, 5000)

    return () => clearInterval(interval)
  }, [dispatch])

  return (
    <SidebarItems
      title='Omat syötteet'
      linkTo='/omat'
      linkToTitle='Näytä kaikki omat uutiset'
      className='user-feeds'
      dispatch={ dispatch }
      loading={ loading }
      failedToLoad={ failedToLoad }
      items={ items }
      emptyText='Lisäämilläsi lähteillä ei löytynyt sisältöä'
    />
  )
}

export default SidebarUserFeed
